export function showHeaderSearchBar(button: HTMLButtonElement, event: Event) {
  event.preventDefault();
  const wrapper = button?.parentElement?.querySelector(
    '[data-form="wrapper"]',
  ) as HTMLDivElement;
  button.classList.toggle("active");
  wrapper.classList.toggle("visible");
}

export function clearSearchInput(button: HTMLButtonElement, event: Event) {
  event.preventDefault();
  const input = button?.parentElement?.querySelector(
    "input",
  ) as HTMLInputElement;
  input.value = "";
}

export function searchOnChange(input: HTMLInputElement) {
  const button = input.parentElement?.parentElement?.querySelector(
    ".header-button-clear",
  );
  if (input.value.length) {
    button?.classList.remove("d-none");
  } else {
    button?.classList.add("d-none");
  }
}
